import { Injectable } from '@angular/core';
import {
  GetMultiAppDataRequest,
  GetMultiAppDataResponse,
  KindValues,
  ListValuesByMultiKindRequest,
  ListValuesByMultiKindResponse,
  MarketplaceApp,
  MarketplaceAppDataApiService,
} from '@vendasta/marketplace-apps';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AppDataService {
  constructor(private appDataApiService: MarketplaceAppDataApiService) {}

  public getMultiAppData(partnerId: string, marketId: string, appId: string[]): Observable<MarketplaceApp[]> {
    return this.appDataApiService
      .getMultiAppData(
        new GetMultiAppDataRequest({
          partnerId: partnerId,
          marketId: marketId,
          appId: appId,
        }),
      )
      .pipe(
        map((resp: GetMultiAppDataResponse) => {
          return (resp || { apps: [] }).apps;
        }),
      );
  }

  public listValuesByMultiKind(scope: string, kinds: string[]): Observable<KindValues[]> {
    return this.appDataApiService
      .listValuesByMultiKind(
        new ListValuesByMultiKindRequest({
          scope: scope,
          kind: kinds,
        }),
      )
      .pipe(
        map((resp: ListValuesByMultiKindResponse) => {
          return (resp || { kinds: [] }).tagValues;
        }),
      );
  }
}
